import React, { useEffect, useState } from "react";
import * as documentAction from "../../../../redux/store/document/document.store";
import Select from "react-select";
import history from "../../../../common/history";
import UrlCollect from "../../../../common/url-collect";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

export const SearchByDistrict1 = (props) => {
    const { setDistrictSelect, onSubmit, name, setName, districtSelect, isLookup} = props;

    const onPressSearch = (e) => {
        if(e.key === 'Enter'){
            onSubmit();
        }
    }
    return (
        <div className="search-planning">
                <div className="input-group mb-3 mt-3">
                    <input
                        type="text"
                        name="name"
                        defaultValue={name}
                        onChange={(data) => setName(data.target.value)}
                        //onClick={() => setName('')}
                        className="form-control"
                        placeholder="Tìm kiếm Khu công nghiệp"
                        aria-label="Tìm kiếm Dự án"
                        aria-describedby="searchFile"
                        onKeyPress={onPressSearch}
                    />
                </div>

                {/* <div className="input-group mb-3 mt-3">
                    <button
                        onClick={onSubmit}
                        type="submit"
                        className="text-uppercase btn btn-info w-100"
                    >
                        <FontAwesomeIcon icon={faSearch} className="mr-1" />
                        Tìm kiếm
                    </button>
                </div> */}
        </div>
    )
}